import { Component } from "@grafikr/components";

export default Component((node, { onMounted }) => {

  function createMobileTable(sections: NodeListOf<HTMLElement>){
    sections.forEach((section:HTMLElement) => {
      const contentMob = document.createElement("a");
      contentMob.href = `#${section.id}`;
      contentMob.classList = 'fixed-table-of-contents-mobile-item';
      const sectionTitle = section.id.replace(/-/g, ' ');
      contentMob.innerHTML = `<span class="fixed-table-of-contents-mobile__container__dot"></span>${sectionTitle}`;
      
      contentMob.addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
          top: section.offsetTop - 145,
          behavior: 'smooth',
        });
      });
      
      const container = node.querySelector(".fixed-table-of-contents-mobile__container")
      container.appendChild(contentMob);
    })
  }

  function activeMobileSection(sections: NodeListOf<HTMLElement>){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const menuItems = document.querySelectorAll('.fixed-table-of-contents-mobile-item');
          menuItems.forEach(el => el.classList.remove('fixed-table-of-contents-mobile-item__active'))
          const activeLink = document.querySelector(`.fixed-table-of-contents-mobile-item[href="#${entry.target.id}"]`);
          activeLink.classList.add('fixed-table-of-contents-mobile-item__active');
          
          if (activeLink && activeLink instanceof HTMLElement) {
            const container = node.querySelector(".fixed-table-of-contents-mobile__container");
            container.scrollTo({
              left: activeLink.offsetLeft + -12,
              behavior: 'smooth'
            });
          }
        }
      });
    }, {
      root: null,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    });

    sections.forEach((section:HTMLElement) => {
      observer.observe(section);
    })
  }

  function initPageScrollProgress() {
    const progress = node.querySelector(".fixed-table-of-contents-mobile__progress-bar") as HTMLElement | null;
    if (!progress) return;

    function updateProgressBar() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progress.style.width = `${scrolled}%`;
    }

    updateProgressBar();
    window.addEventListener('scroll', updateProgressBar, { passive: true });
  }

  function createDesktopTable(sections: NodeListOf<HTMLElement>){
    const main = document.querySelector("main")
    sections.forEach((section:HTMLElement, i:number) => {
      const contentDesk = document.createElement("a");
      contentDesk.href = `#${section.id}`;
      contentDesk.classList = "table-of-contents";
      contentDesk.style.top = `${200 + i * 30}px`;
      const sectionTitle = section.id.replace(/-/g, ' ');
      contentDesk.innerHTML = `<span class="table-of-contents__dot"></span><span>${sectionTitle}</span>`;
      
      contentDesk.addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
          top: section.offsetTop - 106,
          behavior: 'smooth',
        });
      });
      
      main.appendChild(contentDesk);
    })
  }

  function activeDesktopSection(sections: NodeListOf<HTMLElement>){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const menuItems = document.querySelectorAll('.table-of-contents');
          menuItems.forEach(el => el.classList.remove('table-of-contents__active'))
          const activeLink = document.querySelector(`.table-of-contents[href="#${entry.target.id}"]`);
          if (activeLink) {
            activeLink.classList.add('table-of-contents__active');
          }
        }
      });
    }, {
      root: null,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    });

    sections.forEach((section:HTMLElement) => {
      observer.observe(section);
    })
  }

  const init = async () => {
    const sections = document.querySelectorAll<HTMLElement>("[data-table-of-contents-section]");
    
    if (!sections || sections.length === 0) {
      return;
    }

    if (window.innerWidth < 1024) {
      createMobileTable(sections);
      initPageScrollProgress();
      activeMobileSection(sections);
    } else {
      createDesktopTable(sections);
      activeDesktopSection(sections);
    }
  };

  onMounted(init);
}); 